/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Box_Score_SavedInputs */

const th_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกสถิติแล้ว`)
};

const en_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box score saved.`)
};

const ja_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボックススコアを保存しました。`)
};

const zh_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术统计已保存。`)
};

const es_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas guardadas.`)
};

const pt_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas salvas.`)
};

const id_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik pertandingan tersimpan.`)
};

const fr_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feuille de match enregistrée.`)
};

const tl_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-save ang box score.`)
};

const vi_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu thống kê trận.`)
};

const ko_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기 기록을 저장했습니다.`)
};

const de_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielstatistik gespeichert.`)
};

const ru_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика матча сохранена.`)
};

const tr_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maç istatistiği kaydedildi.`)
};

const it_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche della partita salvate.`)
};

const pl_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki meczu zapisane.`)
};

const uk_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистику матчу збережено.`)
};

const hi_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैच के आँकड़े सहेजे गए।`)
};

const ar_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حُفظت إحصاءات المباراة.`)
};

const ms_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik perlawanan disimpan.`)
};

const bn_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলার পরিসংখ্যান সংরক্ষিত হয়েছে।`)
};

const zh_tw2_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術統計已儲存。`)
};

const zh_hk2_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術統計已儲存。`)
};

const ur_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میچ کے اعداد و شمار محفوظ ہو گئے۔`)
};

const fa_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آمار بازی ذخیره شد.`)
};

const sw_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takwimu za mchezo zimehifadhiwa.`)
};

const nl_game_box_score_saved = /** @type {(inputs: Game_Box_Score_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijdstatistieken opgeslagen.`)
};

/**
* | output |
* | --- |
* | "Box score saved." |
*
* @param {Game_Box_Score_SavedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const game_box_score_saved = /** @type {((inputs?: Game_Box_Score_SavedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Box_Score_SavedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_game_box_score_saved(inputs)
	if (locale === "ja") return ja_game_box_score_saved(inputs)
	if (locale === "zh") return zh_game_box_score_saved(inputs)
	if (locale === "es") return es_game_box_score_saved(inputs)
	if (locale === "pt") return pt_game_box_score_saved(inputs)
	if (locale === "id") return id_game_box_score_saved(inputs)
	if (locale === "fr") return fr_game_box_score_saved(inputs)
	if (locale === "tl") return tl_game_box_score_saved(inputs)
	if (locale === "vi") return vi_game_box_score_saved(inputs)
	if (locale === "ko") return ko_game_box_score_saved(inputs)
	if (locale === "de") return de_game_box_score_saved(inputs)
	if (locale === "ru") return ru_game_box_score_saved(inputs)
	if (locale === "tr") return tr_game_box_score_saved(inputs)
	if (locale === "it") return it_game_box_score_saved(inputs)
	if (locale === "pl") return pl_game_box_score_saved(inputs)
	if (locale === "uk") return uk_game_box_score_saved(inputs)
	if (locale === "hi") return hi_game_box_score_saved(inputs)
	if (locale === "ar") return ar_game_box_score_saved(inputs)
	if (locale === "ms") return ms_game_box_score_saved(inputs)
	if (locale === "bn") return bn_game_box_score_saved(inputs)
	if (locale === "zh-TW") return zh_tw2_game_box_score_saved(inputs)
	if (locale === "zh-HK") return zh_hk2_game_box_score_saved(inputs)
	if (locale === "ur") return ur_game_box_score_saved(inputs)
	if (locale === "fa") return fa_game_box_score_saved(inputs)
	if (locale === "sw") return sw_game_box_score_saved(inputs)
	if (locale === "nl") return nl_game_box_score_saved(inputs)
	return en_game_box_score_saved(inputs)
});